/*!
 * Copyright (C) 2017 ProgrammersNG.  All rights reserved.
 * This file is an original work developed by ProgrammersNG
 */

//Calender start

//Date method
function dates(tags) {
  if (tags == "") {
    //If the dates('') paramenter is empty, add no tags
    var dates = "";
    var i;
    for (i = 1; i < 32; i++) {
      dates += i;
    }
  }
  //If the dates('option') has paramenter, add the tags to it
  else {
    var dates = "";
    var i;
    var today_date = new Date();
    for (i = 1; i < 32; i++) {
      if (today_date.getDate() == i) {
        dates +=
          "<" + tags + " selected value='" + i + "'>" + i + "</" + tags + ">";
      } else {
        dates += "<" + tags + " value='" + i + "'>" + i + "</" + tags + ">";
      }
    }
  }

  //You can call the class multiple times
  var multiple_list = document.getElementsByClassName("bear-dates");
  for (i = 0; i < multiple_list.length; i++) {
    multiple_list[i].innerHTML = dates;
  }
}

//Days method
function days(tags) {
  //List all the Days with array
  var list_days = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday",
  ];

  if (tags == "") {
    //If the days('') paramenter is empty, add no tags
    var i;
    for (i = 0, l = list_days.length, days = ""; i < l; i++) {
      days += list_days[i];
    }
  }
  //If the days('option') has paramenter, add the tags to it
  else {
    for (i = 0, l = list_days.length, days = ""; i < l; i++) {
      days += "<" + tags + ">" + list_days[i] + "</" + tags + ">";
    }
  }

  //You can call the class multiple times
  var multiple_list = document.getElementsByClassName("bear-days");
  for (i = 0; i < multiple_list.length; i++) {
    multiple_list[i].innerHTML = days;
  }
}

//Short Days method
function short_days(tags) {
  //List all the Days with array
  var list_days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  if (tags == "") {
    //If the short_days('') paramenter is empty, add no tags
    var i;
    for (i = 0, l = list_days.length, days = ""; i < l; i++) {
      days += list_days[i];
    }
  }
  //If the days('option') has paramenter, add the tags to it
  else {
    for (i = 0, l = list_days.length, days = ""; i < l; i++) {
      days += "<" + tags + ">" + list_days[i] + "</" + tags + ">";
    }
  }

  //You can call the class multiple times
  var multiple_list = document.getElementsByClassName("bear-short-days");
  for (i = 0; i < multiple_list.length; i++) {
    multiple_list[i].innerHTML = days;
  }
}

//Months method
function months(tags) {
  //List all the Days with array
  var list_months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  if (tags == "") {
    //If the months('') paramenter is empty, add no tags
    var i;
    for (i = 0, l = list_months.length, months = ""; i < l; i++) {
      months += list_months[i];
    }
  }
  //If the months('option') has paramenter, add the tags to it
  else {
    var today_date = new Date();
    for (i = 0, l = list_months.length, months = ""; i < l; i++) {
      if (today_date.getMonth() == i) {
        months +=
          "<" +
          tags +
          " selected  value='" +
          i +
          "'>" +
          list_months[i] +
          "</" +
          tags +
          ">";
      } else {
        months +=
          "<" +
          tags +
          " value='" +
          i +
          "'>" +
          list_months[i] +
          "</" +
          tags +
          ">";
      }
    }
  }

  //You can call the class multiple times
  var multiple_list = document.getElementsByClassName("bear-months");
  for (i = 0; i < multiple_list.length; i++) {
    multiple_list[i].innerHTML = months;
  }
}

//Short Months method
function short_months(tags) {
  //List all the Months with array
  var list_months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  if (tags == "") {
    //If the short_months('') paramenter is empty, add no tags
    var i;
    for (i = 0, l = list_months.length, months = ""; i < l; i++) {
      months += list_months[i];
    }
  }
  //If the months('option') has paramenter, add the tags to it
  else {
    for (i = 0, l = list_months.length, months = ""; i < l; i++) {
      months +=
        "<" + tags + " value='" + i + "'>" + list_months[i] + "</" + tags + ">";
    }
  }

  //You can call the class multiple times
  var multiple_list = document.getElementsByClassName("bear-short-months");
  for (i = 0; i < multiple_list.length; i++) {
    multiple_list[i].innerHTML = months;
  }
}

//Year method
function years(tags, startY, endY) {
  if (tags == "") {
    //If the years('') paramenter is empty, add no tags
    var years = "";
    for (i = startY; i < endY + 1; i++) {
      years += i;
    }
  }
  //If the years('option') has paramenter, add the tags to it
  else {
    var years = "";
    var today_date = new Date();
    for (i = startY; i < endY + 1; i++) {
      if (today_date.getFullYear() == i) {
        years +=
          "<" + tags + " selected  value='" + i + "'>" + i + "</" + tags + ">";
      } else {
        years += "<" + tags + " value='" + i + "' >" + i + "</" + tags + ">";
      }
    }
  }

  //You can call the class multiple times
  var multiple_list = document.getElementsByClassName("bear-years");
  for (i = 0; i < multiple_list.length; i++) {
    multiple_list[i].innerHTML = years;
  }
}
//Update days based on selected month and year
function updateDaysInMonth() {
  var month_selects = document.getElementsByClassName("bear-months");
  var year_selects = document.getElementsByClassName("bear-years");
  var date_selects = document.getElementsByClassName("bear-dates");
  
  // Process each calendar instance (in case there are multiple)
  for (var idx = 0; idx < month_selects.length; idx++) {
    var month = parseInt(month_selects[idx].value);
    var year = parseInt(year_selects[idx].value);
    var date_select = date_selects[idx];
    
    if (isNaN(month) || isNaN(year)) continue;
    
    var daysInMonth;
    
    // Months with 31 days: Jan(0), Mar(2), May(4), Jul(6), Aug(7), Oct(9), Dec(11)
    if (month === 0 || month === 2 || month === 4 || month === 6 || 
        month === 7 || month === 9 || month === 11) {
      daysInMonth = 31;
    }
    // February (month = 1) - check for leap year
    else if (month === 1) {
      var isLeapYear = (year % 4 === 0 && year % 100 !== 0) || (year % 400 === 0);
      daysInMonth = isLeapYear ? 29 : 28;
    }
    // Months with 30 days: Apr(3), Jun(5), Sep(8), Nov(10)
    else {
      daysInMonth = 30;
    }
    
    // Get current selected day
    var currentDay = parseInt(date_select.value);
    
    // Hide/show options based on days in month
    var options = date_select.getElementsByTagName("option");
    for (var i = 0; i < options.length; i++) {
      var dayValue = parseInt(options[i].value);
      if (dayValue > daysInMonth) {
        options[i].style.display = "none";
      } else {
        options[i].style.display = "block";
      }
    }
    
    // If current day is now invalid, select the last valid day and trigger update
    if (currentDay > daysInMonth) {
      date_select.value = daysInMonth;
      
      // Trigger the display update function if it exists
      if (typeof changeDateTime === 'function') {
        changeDateTime();
      }
    }
  }
}

//Calender end